import servicePagesData from "./servicePages.json";

export interface ServicePage {
  slug: string;
  cluster: string;
  title: string;
  navLabel: string;
  primaryKeyword: string;
  metaDescription: string;
  heroTitle: string;
  heroDescription: string;
  intro: string;
  outcomes: string[];
  features: string[];
  faqs: Array<{
    question: string;
    answer: string;
  }>;
}

export const servicePages = servicePagesData as ServicePage[];

export function getServicePageBySlug(slug?: string) {
  return servicePages.find((service) => service.slug === slug);
}

export function getServicePageByCluster(cluster?: string) {
  return servicePages.find((service) => service.cluster === cluster);
}
